export default __webpack_public_path__ + "static/media/swap.bc7e41bf.gif";